import React from 'react';
import Table from "react-bootstrap/Table";
import { getObjectViewPageUrl } from '../../../pages/object/ObjectViewPage';
import BaseProps from "../../../types/BaseProps";
import {ResultColumn, ResultItem, Results} from "../../../types/Search";
import ColumnResizer, {ColumnResizerFiller} from "../../resizer/ColumnResizer";

import "./ResultsTable.scss";

type ResultsTableProps = BaseProps & {
  data: Results;
  onResultItemSelected: (item: ResultItem) => void;
};

/**
 * Wrapper component for visualizing search results in table format.
 */
class ResultsTable extends React.Component<ResultsTableProps> {

  onSelectedResult = (item: ResultItem, event: any) => {
    if (event.button === 0) {
      if (event.ctrlKey) {
        window.open(getObjectViewPageUrl(item["id"]));
      } else {
        this.props.onResultItemSelected(item);
      }
    }
  }

  render() {
    const data: Results = this.props.data;
    const columns = data.columns || [];
    const results = data.resultItems || [];

    return <div className="ResultsTable">
      <Table striped bordered hover>
        <thead>
        <TableColumns columns={columns}/>
        </thead>
        <tbody>
        <TableRows results={results} columns={columns}
                   onRowSelection={this.onSelectedResult}/>
        </tbody>
      </Table>
    </div>
  }
}

function TableColumns(props: { columns: Array<ResultColumn> }) {
  const columns: any = [];
  props.columns.forEach((column: ResultColumn, index: number) => {
    columns.push(<th key={index}>{column.label}</th>);
    if (index < props.columns.length - 1) {
      columns.push(<ColumnResizer key={`${index}-resizer`}/>);
    }
  });
  return <tr>{columns}</tr>;
}

function TableRows(props: {
  results: Array<ResultItem>,
  columns: Array<ResultColumn>,
  onRowSelection: (item: ResultItem, event: any) => void
}): any {
  return props.results.map((item: ResultItem, rowIndex: number) => {
    const columns: any = [];
    props.columns.forEach((column: any, colIndex: number) => {
      columns.push(<td key={colIndex}>{item[column.value]}</td>);
      if (colIndex < props.columns.length - 1) {
        columns.push(<ColumnResizerFiller key={`${colIndex}-filler`}/>);
      }
    });
    return <tr key={rowIndex} onClick={(event) => props.onRowSelection(item, event)}>{columns}</tr>;
  });
}

export default ResultsTable;
